class FAQ {
    constructor() {
        $('.faqMenu').on('click', '.js-toggle', function () {
            $(this).closest('.toggleGroup').toggleClass('is-active');
        });
    }
}

$(document).ready(() => {
    new FAQ();
});
